export const ru = {
    need_help: 'Нужна помощь',
};
